import { View, Image, Text, StyleSheet } from "react-native";
import { DateLights } from "../../../assets";
import { isPortrait } from "../../../utils/common";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import {
  formatDate,
  timeAgo,
  getDaysUntilExpiry,
} from "../../../utils/helpers/date";
import { useTranslation } from "react-i18next";
import { selectProfile } from "../../../store/auth/authReducer";

type ProfileUser = {
  username: string;
  avatarFileId: string | null;
  chips: number;
  level: number;
};

type DateInfoProps = {
  user?: ProfileUser;
};

export const DateInfo: React.FC<DateInfoProps> = ({ user }) => {
  const loggedUser = useSelector(selectProfile);
  const effectiveUser = user ?? loggedUser;

  if (!effectiveUser) return null;
  const { t } = useTranslation();
  const registrationDate = useSelector(
    (s: RootState) => s.auth.statistics?.player?.registrationDate,
  );
  const lastLoginDate = useSelector(
    (s: RootState) => s.auth.statistics?.player?.lastLoginDate,
  );
  // vip_expired_at from statistics API, fallback to profile's vipExpiredAt
  const vipExpireFromStats = useSelector(
    (s: RootState) => s.auth.statistics?.player?.vip_expired_at,
  );
  const vipExpireFromProfile = useSelector(
    (s: RootState) => s.auth.user?.vipExpiredAt,
  );
  const vipExpireDate = vipExpireFromStats ?? vipExpireFromProfile;
  const isVip = useSelector((s: RootState) => s.auth.user?.isVip);

  return (
    <View style={styles.wrapper}>
      <View style={styles.lightBar}>
        <Image source={DateLights} style={styles.lightImage} />
      </View>

      <View style={styles.infoContainer}>
        <View style={styles.row}>
          <Text style={styles.label}>
            {t("T_SITE_PROFILE_DATE_REGISTRATION")}:
          </Text>
          <Text style={styles.value}>{formatDate(registrationDate)}</Text>
        </View>

        <View style={styles.row}>
          <Text style={styles.label}>{t("T_SITE_PROFILE_LAST_VISIT")}:</Text>
          <Text style={styles.value}>{timeAgo(lastLoginDate)}</Text>
        </View>
        {isVip && (
          <View style={styles.row}>
            <Text style={styles.label}>{t("T_SITE_PROFILE_VIP_PERIOD")}</Text>
            <Text style={styles.value}>
              {(() => {
                const days = getDaysUntilExpiry(vipExpireDate);
                if (days === null) return "—";
                if (days <= 0) return t("T_SITE_VIP_EXPIRED");
                if (days === 1)
                  return t("T_SITE_NOTIFICATION_EXPIRING_VIP_NEXT_DAY");
                return `${days} ${t("T_SITE_DAYS")}`;
              })()}
            </Text>
          </View>
        )}
      </View>

      <View
        style={{
          marginTop: isPortrait ? -5 : 0,
          marginBottom: isPortrait ? 10 : 10,
        }}
      >
        <Image source={DateLights} style={styles.lightImage} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    marginTop: isPortrait ? 0 : 0,
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  lightBar: {
    marginTop: isPortrait ? 6 : 10,
  },
  lightImage: {
    width: 334,
    height: 8,
  },
  infoContainer: {
    padding: 9,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: isPortrait ? 2 : 6,
  },
  label: {
    color: "white",
    fontSize: isPortrait ? 11 : 14,
    marginRight: 20,
  },
  value: {
    color: "white",
    fontSize: isPortrait ? 11 : 14,
  },
});
